import { Card, Loading, Page, SkeletonBodyText } from "@shopify/polaris";
import React from "react";
import { MainFrameContext } from "../contexts/MainFrameContext";
import MainFrameContextType from "../../types/MainFrameContextType";
import { useDispatch, useSelector } from "react-redux";
import { getInspectionAction } from "../../store/actions/Inspections";
import { InspectionsTable } from "../InspectionsTable";

export default function SurveyorLanding() {
    const inspections = useSelector((state: any) => state.portal.inspections);
    const dispatch = useDispatch();
    const { setShowSideBar } = React.useContext(
        MainFrameContext
    ) as MainFrameContextType;

    setShowSideBar(false);

    React.useEffect(() => {
        dispatch(getInspectionAction());
    }, [dispatch]);

    return (
        <Page fullWidth title="Inspections">
            {inspections === undefined ? (
                <div>
                    <Loading />

                    <Card sectioned>
                        <SkeletonBodyText />
                    </Card>

                    <Card sectioned>
                        <SkeletonBodyText />
                    </Card>
                </div>
            ) : (
                <Card>
                    <InspectionsTable data={inspections} />
                </Card>
            )}
        </Page>
    );
}
